export interface BannerCpcTask {
  id: number;
  type: string;
  view_details: {
    title: string;
  };
  details: Record<string, any>;
  target_progress: number;
  user_progress: number;
  rewards: {
    stars: number;
  };
  status: 'active' | 'completed' | 'expired' | 'done' | 'claim' | 'sleep';
}

export interface BannerCpcResponse {
  status: 'success' | 'error';
  error?: string;
  tasks?: BannerCpcTask[];
}

export enum BannerCpcStatus {
  Active = 'active',
  Completed = 'completed',
  Expired = 'expired',
  Claim = 'claim',
  Sleep = 'sleep',
}
